import React from 'react';

const EyeCenter = ({ center, radius = 30 }) => {
  return (
    <g>
      <defs>
        <clipPath id="earth-clip">
          <circle cx={center} cy={center} r={radius} />
        </clipPath>
      </defs>
      
      {/* Outer Glow / Atmosphere */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="var(--accent-indigo)"
        strokeWidth="2"
        style={{ filter: "drop-shadow(0 0 8px var(--accent-indigo))" }}
      />
      
      {/* Earth Image */}
      <image
        href="/assets/earth_center.webp"
        x={center - radius}
        y={center - radius}
        width={radius * 2}
        height={radius * 2}
        clipPath="url(#earth-clip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </g>
  );
};

export default EyeCenter;
